import React, { useEffect, useState } from "react";
import ReactHtmlParser from 'react-html-parser';
import "./TermsBottomSheetModal.scss";
import { getTermsConditions } from "../../../../../actions";
import LoadingOverlay from "react-loading-overlay";
import { useDispatch, useSelector } from "react-redux";
import SkinAssessmentButton from "../../../../../common/skinAssessmentButton/SkinAssessmentButton";

const TermsBottomSheetModal = ({ onClose, onAccept }) => {
    const [close, setClose] = useState(false);
    const [termsContent, setTermsContent] = useState("");

    const { assessmentTerms } = useSelector((state) => state.assessment);

    const dispatch = useDispatch();

    useEffect(() => {
        if (assessmentTerms) {
            setTermsContent(assessmentTerms?.data?.content);
        }
        else {
            fetchTermsData();
        }
    }, []);

    async function fetchTermsData() {
        const res = await dispatch(getTermsConditions('skinAssessment'));
        setTermsContent(res?.data?.content);
    }

    const onCloseHandler = () => {
        setClose(true);
        onClose();
    }

    if (!termsContent) {
        return <div> <LoadingOverlay
            active={true}
            spinner
            text="Loading"
            styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', pointerEvents: 'none' } }}
        /></div>;
    }
    return (
        <div className="bottom-sheet-overlay">
            <div className="bottom-sheet-backdrop" onClick={onCloseHandler}>
                <div
                    className={`bottom-sheet ${close ? "closing" : "open"}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="bottom-sheet-content">{ReactHtmlParser(termsContent)}</div>
                    <div className="bottom-sheet-footer">
                        <SkinAssessmentButton btnClassName="modal-gradient-btn home-start-gradient" onBtnClick={onAccept}>ยอมรับเงื่อนไข</SkinAssessmentButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsBottomSheetModal;